module.exports = __webpack_public_path__ + "assets/img/654300.9e822b94.png";